"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProfileDefault;
(function (ProfileDefault) {
    ProfileDefault["PROFILE_SUPERADMIN"] = "PROFILE_SUPERADMIN";
    ProfileDefault["PROFILE_MEGAPLUS"] = "PROFILE_MEGAPLUS";
    ProfileDefault["PROFILE_DISTRIBUTOR"] = "PROFILE_DISTRIBUTOR";
    ProfileDefault["PROFILE_MEGANET_ADMIN"] = "PROFILE_MEGANET_ADMIN";
    ProfileDefault["PROFILE_CLIENT"] = "profileClient-w8bfo4";
    ProfileDefault["PROFILE_CLIENT_01"] = "profileClient01-vfnq0d";
})(ProfileDefault = exports.ProfileDefault || (exports.ProfileDefault = {}));
exports.DEFAULT_PROFILE_ID = ProfileDefault.PROFILE_CLIENT;
exports.DEFAULT_NPP_ACCOUNT_ID = '5d5bbcea884d73567cf3fd60';
//# sourceMappingURL=profile.js.map